<template>
    <default-layout>
        <BreadcrumLayout>
            <div class="flex">
                <a href="#" class="link-color"><U>Planning</U></a>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mt-1" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                </svg>
                <a href="#" class="link-color"><U>Food Orders</U></a></div>
        </BreadcrumLayout>
        <PageTitleLayout>
            <div class="w-full flex flex-wrap justify-between items-center">
                <h1 class="heading-color xl:text-4xl text-2xl font-bold text-left">Create Order</h1>

                <div class="right-button">
                    <inertia-link :href="route('food-orders')" class="">
                        <button class="cancel-button-color text-white font-bold py-3 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-0 rounded lg:mt-0 sm:mt-0">
                            CANCEL
                        </button>
                    </inertia-link>


                    <!-- <inertia-link :href="route('foodorderdetail-next')" class=""> -->
                        <button @click="CreateFoodOrder" class="button-color text-white font-bold py-3 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0">
                            NEXT
                        </button>
                    <!-- </inertia-link> -->
                </div>
            </div>

        </PageTitleLayout>

        <div class="order-detail xl:px-10 px-5">
            <p class="text-base">Order for: Placentia Linda West</p>
        </div>
        <TableIndexLayout>
            <div class="food-order xl:px-10 px-5 mt-6">
                <h3 class="progress-text font-bold">Progress: Step 3 of 4</h3>
                <div class="w-full progress-bar">
                    <div class="py-0.5 text-xs text-center text-white bg-green-500 w-1/2">50%</div>
                </div>
            </div>
        </TableIndexLayout>

        <PageTitleLayout>

        </PageTitleLayout>

        <div class="lg:mb-0 mb-4 w-full mt-6 flex xl:px-10 px-5">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="#0093d0">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg><span class="span-text font-bold pl-1">Confirm the order quantities for each delivery location:</span>
        </div>
        <div >
            

            <div  class="flex flex-col mb-6 mx-10 my_table">
                <div class="overflow-x-auto">
                    <div class="align-middle inline-block min-w-full">
                        <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
                            <table class="min-w-full">
                                <thead class="header-bg-color">
                                    <tr>
                                        <th scope="col" class="w-3/5 id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                                            Products
                                        </th>
                                        <th scope="col"
                                            class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            Distributor
                                        </th>
                                        <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            needed
                                        </th>
                                        <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            on hand
                                        </th>
                                        <th scope="col" class="w-1/5 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                                            order
                                        </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- Oddd row -->
                                    <tr v-for="(preferProduct, product) in preferProducts "  :key="product" class="bg-white">
                                        <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
                                            <!-- Tyson-Frozen 1/4 Ib Beef Patty -->
                                            <a target="_blank" :href="route('products_edit',{ id: preferProduct.product_id })"> {{ preferProduct.product_name }}</a>
                                        </td>
                                        <td class="py-4 whitespace-nowrap text-base text-color td-background-color">
                                            <div class="relative focus:outline-none sm:w-60 w-50 xl:pl-4 pl-0 xl:mt-0 mt-4"><select v-model="preferProduct.distributor_id" class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height 2xl:text-base text-base text-gray-400">
                                                <option value="">Select Distributor</option>
                                                <option v-for="(i, value)  in preferProduct.distributors" :value="value">{{ i  }}</option>
                                            </select>
                                            <div class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none"><i class="fa fa-sort-desc" aria-hidden="true"></i></div></div>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
                                            {{ preferProduct.student_count }}
                                        </td>

                                        <td  class="px-6 py-4 whitespace-nowrap text-base text-color">
                                            <input v-model="preferProduct.needed"  @change="changeOrderValue(preferProduct)"    type="text" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                                        </td>

                                        <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                                           {{ preferProduct.student_count - (preferProduct.needed > preferProduct.student_count ? 0 : preferProduct.needed) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p>
        </p>
        <div class="bottom_button w-full sm:flex lg:flex-nowrap flex-nowrap lg:justify-end items-center  mb-6  px-10 mt-6">
            <inertia-link :href="route('food-orders')" class="">
                <button class="cancel-button-color text-white font-bold py-1.5 xl:px-8 sm:px-8 px-4 lg:ml-6  ml-0 rounded lg:mt-0 sm:mt-0 xl:mt-10">
                    CANCEL
                </button>
            </inertia-link>
                <button @click="CreateFoodOrder" class="button-color text-white font-bold py-1.5 xl:px-8 sm:px-8 px-4 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 xl:mt-10">
                    NEXT
                </button>
        </div>
    </default-layout>
    </template>

    <script>
    import DefaultLayout from "@/Layouts/DefaultLayout";
    import Welcome from "@/Jetstream/Welcome";
    import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
    import PageTitleLayout from "@/Pages/Common/PageTitle";
    import TableFilterLayout from "@/Pages/Common/TableFilters";
    import TableIndexLayout from "@/Pages/Common/TableIndex";

    export default {
        data(){
            return {
                isOpenOffering:[Object.keys(this.preferProducts)[0]],
                inputValue: ''
            }
        },

        props: ['preferProducts', 'order_id'],

        components: {
            DefaultLayout,
            Welcome,
            BreadcrumLayout,
            PageTitleLayout,
            TableFilterLayout,
            TableIndexLayout,
        },
        methods: {
            accordianShow(offering) {
                console.log('accordian show', offering);
                this.isOpenOffering.push(offering);
                // this.isOpenOffering = ! this.isOpenOffering;
                console.log('accordian array', this.isOpenOffering);

            },
            accordianHide(offering) {
                console.log('accordian hide', offering);
                const index = this.isOpenOffering.indexOf(offering);
                if (index > -1) { // only splice array when item is found
                    this.isOpenOffering.splice(index, 1); // 2nd parameter means remove one item only
                }
                console.log('accordian array', this.isOpenOffering);
            },

            changeOrderValue(preferProductItem){
                if (preferProductItem.needed > preferProductItem.student_count) {
                        preferProductItem.needed = 0;
                }
            },
            CreateFoodOrder(){
                console.log('data', this.preferProducts);
                axios
                .post("/food-order/store/step-3", {
                    order_id: this.order_id,
                    data: this.preferProducts
                })
                .then((response) => {
                    // console.log('food-order.store.step-4', response);
                    if(response.data.status == 'success'){
                        window.location.href = `create4?order_id=${response.data.data.id}`;
                    }
                    // console.log(response.data.status);
                })
                .catch((error) => console.error(error));
            },
        }

    };
    </script>

    <style>
    .title::after,
    .title::before {
        content: '';
        position: absolute;
        right: 1.25em;
        top: 1.25em;
        width: 2px;
        height: 0.75em;
        background-color: #7A7572;
        transition: all 0.2s;
    }

    .content p {
        padding: 20px;
    }

    .min-height-third {
        min-height: 400px;
    }

    .span-text {
        font-size: 14px;
        color: #727272;
        padding-bottom: 5px;
    }

    .progress-bar>div {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        height: 23px;
        line-height: 23px;
    }

    .progress-text {
        font-size: 19px;
        color: #3f3f3f;
    }

    .progress-bar {
        background-color: #fff;
        border: 1px solid #cacaca;
        border-radius: 5px;
        height: 25px;
    }

    .bg-green-500 {
        background-color: #22af4b;
    }

    .sm\:text-sm {
        font-size: 0.850rem;
        line-height: 1.25rem;
    }

    .order-detail {
        color: #4a4a4a;
        font-size: 14px;
    }

    .w-52-rec {
        width: 13.2rem;
    }

    .cancel-button-color {
        background-color: #8b8b8b;
    }

    .input-background {
        background-color: #f8f8f8;
    }

    .text-base-heading {
        font-size: 14px;
    }

    .button-bg-color-wed-menu2-gray {
        border: none !important;
        min-height: 35px;
        min-width: 35px;
    }

    .menu1-background-color {
        background-color: #FAA43D;
    }

    .button-bg-color-wed-menu2 {
        background-color: #38558e;
        border: none !important;
        min-height: 35px;
        min-width: 35px;
    }

    .menu1-icon-color {
        color: #38558e;
    }

    .id-color-menu-edit {
        color: #F7A53A;
    }

    .bg-button-color {
        background-color: #cb0000;
    }

    .min-w-min-button {
        min-height: 26px;
        min-width: 53px;

    }

    .w-150 {
        width: 150px;
    }

    .max-w-0-menu1 {
        max-width: 4rem;
    }

    .bg-button-color-green {
        background-color: #22af4b;
    }

    .bg-button-color-gray {
        background-color: #636363;
    }

    .bg-hard-grey {
        background-color: #f4f4f4;
    }

    .font-size-edit {
        font-size: 10.5px;
    }

    .w-96-edit-recipes {
        width: 35rem;
    }

    .select-menu-height-edit2 {
        height: 2.8rem;
    }

    @media screen and (min-width: 1500px) {
        .id_arrow .fa-sort-desc:before {
            content: "\f0dd";
            position: absolute;
            top: 16px;
            left: 43px;
            padding-left: 7px;
            color: #219FD5;
        }

        .id_arrow .fa-sort-asc:before {
            content: "\f0de";
            color: #219FD5;
            padding-left: 7px;
            position: absolute;
            top: 16px;
            left: 43px;
        }
    }

    @media screen and (max-width: 1499px) {
        .id_arrow .fa-sort-asc:before {
            content: "\f0de";
            color: #219FD5;
            padding-left: 7px;
            position: absolute;
            top: 28px;
            left: 43px;
        }

        .id_arrow .fa-sort-desc:before {
            content: "\f0dd";
            position: absolute;
            top: 28px;
            left: 43px;
            padding-left: 7px;
            color: #219FD5;
        }
    }

    @media screen and (max-width: 1279px) {
        .searching-background-color {
            margin-left: 1.25rem;
            margin-right: 1.25rem;
        }

        .my_table {
            margin-left: 1.25rem;
            margin-right: 1.25rem;
        }

        .bottom_button {
            padding-right: 1.25rem;
            padding-left: 1.25rem;
        }
    }

    @media screen and (max-width: 570px) {

        .right-button,
        .order-detail {
            margin-top: 0.625rem;
        }
    }
    </style>
